/** Modelo del filtro de período, separado del componente para no romper HMR. */

export interface Period {
  periodFrom: string;
  periodTo: string;
}

/** Por defecto: el año en curso hasta hoy. */
export function defaultPeriod(): Period {
  const today = new Date();
  return {
    periodFrom: `${today.getUTCFullYear()}-01-01`,
    periodTo: today.toISOString().slice(0, 10),
  };
}
